import React, { useState, useEffect } from 'react';
import { Button, Card, notification, Modal } from 'antd';
import { MainContainer } from './Product.styles';
import TableComponent from './table/Table';
import ProductModal from './ProductModal/ProductModal';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { postProduct, getAllProduct, deleteProduct, updateProduct } from 'utils/apis/configProduct';
import { getAllProductCategory } from 'utils/apis/configProductCategory';

const Product = () => {
  const [isVisible, setVisible] = useState(false);
  const [isWarningVisible, setWarningVisible] = useState(false);

  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [productCategoryData, setProductCategoryData] = useState([]);
  const [linkedPricingTablesWarning, setLinkedPricingTablesWarning] = useState([]);

  useEffect(() => {
    //not sure why after closing the warningModal, the visible is automatically set to hidden ?? temp workaround i guess.
    if (isWarningVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
    fetchData();
  }, [isWarningVisible]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const product = await getAllProduct();
      const productCategory = await getAllProductCategory();
      setProductData(product.data);
      setProductCategoryData(productCategory.data);
      console.log(product.data);
    } catch (error) {
      console.error('Error fetching Product data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSelectedProduct = product => {
    setSelectedProduct(product);
    setVisible(true);
  };
  const showModal = () => {
    setVisible(true);
  };
  const closeModal = () => {
    setVisible(false);
  };

  const handleSubmit = async (values, selectedProductId) => {
    try {
      if (selectedProductId === 'new') {
        await postProduct(values);
        notification.success({
          message: 'Success',
          description: 'Product has been created successfully.'
        });
      } else {
        await updateProduct(selectedProductId, values);
        notification.success({
          message: 'Success',
          description: 'Product has been updated successfully.'
        });
      }
      fetchData();
    } catch (error) {
      console.error('Error submitting Product:', error);
    }
  };

  const handleDelete = async selectedProductId => {
    try {
      const product = productData.filter(product => product._id === selectedProductId);

      if (product[0].linkedPricingTables.length > 0) {
        const linkedPricingTables = product[0].linkedPricingTables.map(product => product.name);
        setLinkedPricingTablesWarning(linkedPricingTables);
        setWarningVisible(true);
        return;
      }

      const deleted = await deleteProduct(selectedProductId);
      notification.success({
        message: 'Deleted',
        description: 'Product has been deleted successfully.'
      });
      fetchData();
    } catch (error) {
      console.error('Error deleting Product:', error);
      notification.success({
        message: 'Deleted',
        description: `Encoutered Problem ${error}`
      });
    }
  };

  const closeWarningModal = () => {
    setWarningVisible(false);
    setLinkedPricingTablesWarning(''); // Optionally, reset any other state related to the Modal
    document.body.style.overflow = 'visible';
  };

  return (
    <>
      <MainContainer>
        <Button onClick={showModal} style={{ marginBottom: '40px' }} type="primary">
          Create Product
        </Button>
        <Card>
          <TableComponent
            data={productData}
            loading={isLoading}
            onSelectedProduct={handleSelectedProduct}
            productCategoryData={productCategoryData}
          />
        </Card>
        <ProductModal
          data={productData}
          offVisible={closeModal}
          visibility={isVisible}
          onSubmit={handleSubmit}
          fetchData={fetchData}
          selectedProduct={selectedProduct}
          resetProduct={() => setSelectedProduct('')}
          onDelete={handleDelete}
          productCategoryData={productCategoryData}
        />
      </MainContainer>
      {linkedPricingTablesWarning && (
        <Modal
          title={
            <span>
              <ExclamationCircleOutlined style={{ color: 'red', marginRight: '8px' }} />
              Cannot Delete
            </span>
          }
          visible={isWarningVisible}
          onCancel={closeWarningModal}
          footer={null}
        >
          <p>This products is linked to the following pricing table(s), please remove them before deleting:</p>
          <ul>
            {linkedPricingTablesWarning.map((pricingTableName, index) => (
              <li key={index}>{pricingTableName}</li>
            ))}
          </ul>
        </Modal>
      )}
    </>
  );
};

export default Product;
